module.exports = __webpack_public_path__ + "static/media/loading.0f8c7134.gif";